import { css } from 'lit-element'
export default css`
  /* upsells */

  .tailwind .cart-drawer_upsells-container {
    display: flex;

    flex-grow: 1;

    flex-direction: column;
  }

  .tailwind .cart-drawer_upsells-container.is-empty {
    display: none;
  }

  .tailwind .cart-drawer_upsells {
    display: flex;

    flex-grow: 1;

    flex-direction: column;

    justify-content: flex-end;

    border-top-width: 1px;

    border-bottom-width: 0px;

    border-right-width: 0px;

    border-left-width: 0px;

    border-style: solid;

    --tw-border-opacity: 1;

    border-color: rgb(228 228 231 / var(--tw-border-opacity));

    --tw-bg-opacity: 1;

    background-color: rgb(245 244 244 / var(--tw-bg-opacity));

    padding-top: 1rem;
  }

  .tailwind .cart-drawer_upsells h3 {
    margin: 0px;

    padding-left: 1.25rem;

    padding-right: 1.25rem;
  }

  .tailwind .side-cart-upsell-card-header {
    font-family: Beatrice, Arial, Helvetica, sans-serif;

    font-size: 1.125rem;

    line-height: 1.75rem;

    font-weight: 700;

    line-height: 130%;

    --tw-text-opacity: 1;

    color: rgb(35 31 32 / var(--tw-text-opacity));
  }

  .tailwind .side-cart-upsell-card-subheader {
    margin-top: 0.25rem;

    font-family: Beatrice, Arial, Helvetica, sans-serif;

    font-size: 0.875rem;

    line-height: 1.25rem;

    font-weight: 400;

    line-height: 148%;

    --tw-text-opacity: 1;

    color: rgb(35 31 32 / var(--tw-text-opacity));
  }

  .tailwind .side-cart-upsell-products {
    margin: 0px;

    display: flex;

    scroll-snap-type: x var(--tw-scroll-snap-strictness);

    --tw-scroll-snap-strictness: mandatory;

    list-style-type: none;

    align-items: center;

    gap: 0.75rem;

    overflow-x: scroll;

    padding-top: 1rem;

    padding-bottom: 1rem;

    padding-left: 1.25rem;

    padding-right: 1.25rem;

    -ms-overflow-style: none;

    scrollbar-width: none;
  }

  .tailwind .side-cart-upsell-products::-webkit-scrollbar {
    display: none;
  }

  .tailwind .side-cart-upsell-card {
    display: flex;

    width: 300px;

    scroll-snap-align: center;

    --tw-bg-opacity: 1;

    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  }

  @media (min-width: 768px) {
    .tailwind .side-cart-upsell-card {
      width: 360px;
    }
  }

  .tailwind .side-cart-upsell-card {
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
    align-self: normal;
  }

  .tailwind .side-cart-upsell-card-image-container {
    position: relative;

    display: flex;

    aspect-ratio: 1 / 1;

    height: 100%;

    width: 100%;

    max-width: 150px;

    justify-content: center;

    gap: 0px;

    --tw-bg-opacity: 1;

    background-color: rgb(213 194 172 / var(--tw-bg-opacity));
  }

  @media (min-width: 768px) {
    .tailwind .side-cart-upsell-card-image-container {
      width: 80%;
    }
  }

  .tailwind .side-cart-upsell-card-image-container img {
    position: relative;

    top: 0.5rem;

    height: auto;

    align-self: center;

    object-fit: contain;
  }

  .tailwind .side-cart-upsell-badge-text {
    position: absolute;

    top: 0px;

    right: 0px;

    --tw-bg-opacity: 1;

    background-color: rgb(253 189 76 / var(--tw-bg-opacity));

    padding: 0.25rem;

    font-family: Beatrice, Arial, Helvetica, sans-serif;

    font-size: 0.75rem;

    line-height: 1rem;

    font-weight: 700;

    text-transform: uppercase;

    line-height: 130%;

    letter-spacing: 0.863px;

    --tw-text-opacity: 1;

    color: rgb(35 31 32 / var(--tw-text-opacity));
  }

  .tailwind .side-cart-upsell-card-details {
    display: flex;

    width: 100%;

    flex-direction: column;

    justify-content: space-between;

    gap: 1rem;

    padding: 0.75rem;
    width: inherit;
  }

  .tailwind .side-cart-upsell-card-details > div {
    display: flex;

    flex-direction: column;

    gap: 0.25rem;
  }

  .tailwind .side-cart-upsell-card-title {
    font-family: Beatrice, Arial, Helvetica, sans-serif;

    font-size: 0.875rem;

    line-height: 1.25rem;

    font-weight: 700;

    line-height: 132%;

    --tw-text-opacity: 1;

    color: rgb(35 31 32 / var(--tw-text-opacity));
  }

  .tailwind .side-cart-upsell-card-category {
    font-family: Beatrice, Arial, Helvetica, sans-serif;

    font-size: 0.875rem;

    line-height: 1.25rem;

    font-weight: 400;

    line-height: 132%;

    --tw-text-opacity: 1;

    color: rgb(35 31 32 / var(--tw-text-opacity));
  }

  .tailwind .side-cart-upsell-card-price {
    font-family: Beatrice, Arial, Helvetica, sans-serif;

    font-size: 0.875rem;

    line-height: 1.25rem;

    font-style: italic;

    line-height: 132%;

    --tw-text-opacity: 1;

    color: rgb(110 110 115 / var(--tw-text-opacity));
  }

  .tailwind .side-cart-upsell-card-details add-button button {
    width: 100%;

    border-width: 1px;

    --tw-border-opacity: 1;

    border-color: rgb(35 31 32 / var(--tw-border-opacity));

    --tw-bg-opacity: 1;

    background-color: rgb(255 255 255 / var(--tw-bg-opacity));

    padding-top: 6px;

    padding-bottom: 6px;

    padding-left: 0.75rem;

    padding-right: 0.75rem;

    font-family: Beatrice, Arial, Helvetica, sans-serif;

    font-size: 0.75rem;

    line-height: 1rem;

    font-weight: 700;

    text-transform: uppercase;

    letter-spacing: 1px;

    --tw-text-opacity: 1;

    color: rgb(35 31 32 / var(--tw-text-opacity));

    transition-duration: 200ms;
  }

  @media (hover: hover) and (pointer: fine) {
    .tailwind .side-cart-upsell-card-details add-button button:hover {
      --tw-bg-opacity: 1;

      background-color: rgb(35 31 32 / var(--tw-bg-opacity));

      --tw-text-opacity: 1;

      color: rgb(255 255 255 / var(--tw-text-opacity));
    }
  }
`
